/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/ExitToApp';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ExitToAppIcon = withMuiAdapter(Base, 'ExitToApp');
